
<template>
    
        <mars-view class="online-consult-card" :class="{'online-consult-card-border': pageForm === 'qalandpage/selected'}" @click.native="turnIm"><mars-view v-if="cardType === 'native'" class="native-ad"><mars-image class="native-ad-image" :src="nativeAdInfo.image"></mars-image><mars-view><mars-view class="native-ad-title">{{ nativeAdInfo.title }}</mars-view><mars-view class="native-ad-subtitle">{{ nativeAdInfo.subtitle }}</mars-view><mars-view class="native-ad-btn">{{ nativeAdInfo.btnText }}</mars-view></mars-view></mars-view><mars-view v-else-if="cardType === 'joinCard'" class="join-card-box"><join-card fr="sp-question-lsylk-5"></join-card></mars-view><mars-view v-else-if="cardType === 'banner'"><mars-view class="banner-ad" :class="{'banner-ad-regulation': adType === 'banner_ad4' || adType === 'banner_ad5'}"><mars-view v-if="consultCount && adType === 'banner_ad1'" class="banner-ad-title">
                浏览更多不如直接问，<mars-text class="blue-font">{{ consultCount }}</mars-text>人正在咨询
            </mars-view><mars-view v-if="lawyerCount && (adType === 'banner_ad2' || adType === 'banner_ad5')" class="banner-ad-title"><mars-text class="blue-font">{{ lawyerCount }}</mars-text>律师在线服务，高效解决您的问题
            </mars-view><mars-view v-if="bannerAdInfo.bgImage" class="banner-ad-img" :class="{'banner-ad-img-3': adType === 'banner_ad3'}" :style="'background-image: url(' + bannerAdInfo.bgImage + ')'"><mars-view v-if="bannerAdInfo.title" class="banner-ad-text l-font-semibold">{{ bannerAdInfo.title }}</mars-view><mars-view v-if="bannerAdInfo.btnText" class="banner-ad-button l-font-medium">{{ bannerAdInfo.btnText }}</mars-view></mars-view></mars-view></mars-view><mars-view v-else><mars-view v-if="adType === 'lawyer' && recommendLawyers" class="lawyers-box" @click.native.stop><mars-view class="lawyer-title">{{ recommendLawyers.title }}</mars-view><mars-view class="shadow shadow-left"></mars-view><mars-view class="shadow shadow-right"></mars-view><mars-view class="lawyer-list"><mars-view class="lawyer-list-scroll"><mars-view v-for="item in recommendLawyers.list" :key="item.lawyer_name" class="lawyer-list-scroll-item" @click.native.stop="handleLawyer(item)"><mars-view class="lawyer-img"><mars-image class="lawyer-img-item" :src="item.lawyer_avatar"></mars-image><mars-view v-if="item.members_icon" class="lawyer-img-vip">{{ item.members_icon }}</mars-view></mars-view><mars-view class="lawyer-name">{{ item.lawyer_name }}</mars-view><mars-view class="lawyer-years">{{ item.practice_year }}</mars-view><mars-view v-if="item.lawyer_service" class="lawyer-btn" @click.native.stop="handleLawyerConsult(item.lawyer_service[0], item.target, item.lawyer_name)">
                            咨询我
                            <login-button v-if="item.lawyer_service && item.lawyer_service[0].pay_ui && canIUseLoginButton && platform !== 'web'" class="cell-item-login" class-name="cell-item-login" @callBackSucc="handleLawyerConsult(item.lawyer_service[0], item.target, item.lawyer_name)"></login-button></mars-view></mars-view><mars-view v-if="recommendLawyers.btn" class="lawyer-list-scroll-item" @click.native.stop="handleLawyer(recommendLawyers.btn)"><mars-view class="lawyer-more">更多律师</mars-view><mars-view class="lawyer-btn">{{ recommendLawyers.btn.txt }}</mars-view></mars-view></mars-view></mars-view></mars-view></mars-view></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */
import { ubcClickInit } from '../../static/utils/ubcMethods';
import { act } from '../../static/utils/navigate.js';
import { getQueryObject } from '../../static/utils/core';
import log from '../../static/utils/ubcLog';
import loginButton from "../loginButton/index.vue";
import joinCard from "../../components/common/joinCard.vue";
const nativeMapInfo = {
  native_ad1: {
    title: '一对一在线问律师',
    subtitle: '一分钟提问，获得专业解答',
    btnText: '免费咨询',
    image: 'https://law-smartapp.cdn.bcebos.com/banner/ad-1.png'
  },
  native_ad2: {
    title: '还有疑问？快速问律师',
    subtitle: '一分钟提问，获得针对解答',
    btnText: '立即咨询',
    image: 'https://law-smartapp.cdn.bcebos.com/banner/ad-2.png'
  },
  native_ad3: {
    title: '在线问律师',
    subtitle: '一分钟提问，获取专业解答',
    btnText: '快速提问',
    image: 'https://law-smartapp.cdn.bcebos.com/banner/ad-2.png'
  }
};
const bannerMapInfo = {
  banner_ad1: {
    bgImage: 'https://law-smartapp.cdn.bcebos.com/banner/banner1.png'
  },
  banner_ad2: {
    bgImage: 'https://law-smartapp.cdn.bcebos.com/banner/banner2.png'
  },
  banner_ad3: {
    bgImage: 'https://lvlin-base.cdn.bcebos.com/law/pages/select/banner.png'
  },
  banner_ad4: {
    title: '没找到合适律师？可直接提问',
    btnText: '在线咨询',
    bgImage: 'https://law-smartapp.cdn.bcebos.com/banner/banner-bg2.png'
  },
  banner_ad5: {
    title: '一分钟提问，获取专业解答',
    btnText: '在线问律师',
    bgImage: 'https://law-smartapp.cdn.bcebos.com/banner/banner-bg2.png'
  }
};
export default {
  name: 'onlineConsultCard',
  components: {
    'login-button': loginButton,
    joinCard
  },
  props: {
    // 咨询卡片类型
    adType: {
      type: String,
      default: 'native_ad1'
    },
    // 咨询卡片跳转url
    adUrl: {
      type: String,
      default: ''
    },
    // 律师数量
    lawyerCount: {
      type: [Number, String],
      default: 0
    },
    // 咨询数量
    consultCount: {
      type: Number,
      default: 0
    },
    // 排序
    order: {
      type: Number,
      default: 0
    },
    // 相关律师
    recommendLawyers: {
      type: Object,
      default() {
        return null;
      }
    },
    // 页面来源
    pageForm: {
      type: String,
      default: 'qalandpage/selected'
    },
    // ubc埋点信息
    ubcInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      canIUseLoginButton: getApp().globalData.canIUseLoginButton,
      platform: getApp().globalData.platform
    };
  },
  computed: {
    nativeAdInfo() {
      return nativeMapInfo[this.adType] || {};
    },
    bannerAdInfo() {
      return bannerMapInfo[this.adType] || {};
    },
    cardType() {
      return this.adType.includes('banner') ? 'banner' : this.adType.includes('native') ? 'native' : this.adType;
    }
  },
  methods: {
    turnIm() {
      if (this.pageForm === 'qalandpage/selected') {
        let value = 'recommend1-consult-click';
        if (this.adType === 'banner_ad1' || this.adType === 'banner_ad2') {
          value = 'recommend2-consult-click';
        } else if (this.adType === 'banner_ad3') {
          value = 'recommend3-consult-click';
        }
        ubcClickInit({
          page: 'qalandpage/selected',
          value,
          ext: {
            consult_type: 'online-chat',
            recommend_location_index: this.order
          }
        });
        this.$emit('turnIm');
      } else {
        act({
          target: this.adUrl || ''
        });
      }
    },
    handleLawyer({
      type,
      target,
      lawyer_name
    }) {
      log.send({
        area: 'all-click',
        action: 'click'
      });
      act({
        type: 'url',
        target: target + '&fr=selected'
      });
      const urlParams = getQueryObject(target);
      ubcClickInit({
        page: 'qalandpage/selected',
        value: 'law_lawyer_card_click',
        ext: {
          name: lawyer_name,
          qc_no: urlParams.qc_no
        }
      });
    },
    handleLawyerConsult({
      type,
      target_url
    }, url, name) {
      act({
        type: 'url',
        target: target_url
      });
      const urlParams = getQueryObject(url);
      ubcClickInit({
        page: 'qalandpage/selected',
        value: 'law_lawyer_card_click_call',
        ext: {
          name: name,
          qc_no: urlParams.qc_no
        }
      });
    }
  }
};
</script>

<style scoped>
.online-consult-card {
  margin: 0 auto;
}
.online-consult-card .native-ad {
  box-sizing: border-box;
  padding: 0.18rem 0;
  display: flex;
  justify-content: flex-start;
}
.online-consult-card .native-ad-title {
  font-size: 0.18rem;
  line-height: 0.18rem;
  color: #1f1f1f;
  font-weight: 500;
}
.online-consult-card .native-ad-subtitle {
  font-size: 0.15rem;
  line-height: 0.15rem;
  color: #555;
  margin: 0.1rem 0;
}
.online-consult-card .native-ad-btn {
  width: 19.3237vw;
  height: 6.7633vw;
  line-height: 6.7633vw;
  background-color: #445fbb;
  color: #fff;
  font-size: 3.3816vw;
  text-align: center;
  border-radius: 39.8551vw;
}
.online-consult-card .native-ad-image {
  width: 28.3414vw;
  height: 19.0016vw;
  border-radius: 4px;
  margin-right: 0.15rem;
}
.online-consult-card .join-card-box {
  padding: 0.18rem 0 0.12rem;
}
.online-consult-card .banner-ad {
  padding: 0.18rem 0;
}
.online-consult-card .banner-ad-title {
  font-size: 0.18rem;
  line-height: 0.18rem;
  color: #1f1f1f;
  margin-bottom: 0.15rem;
  text-align: center;
}
.online-consult-card .banner-ad-img {
  height: 0.83rem;
  background-image: url('https://law-smartapp.cdn.bcebos.com/banner/banner1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 0.12rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.online-consult-card .banner-ad-img-3 {
  height: 1.57rem;
}
.online-consult-card .banner-ad-text {
  width: fit-content;
  height: 0.2rem;
  font-size: 0.2rem;
  color: #fff;
  line-height: 0.2rem;
  font-weight: 600;
}
.online-consult-card .banner-ad-button {
  width: fit-content;
  height: 0.28rem;
  padding: 0 0.21rem;
  line-height: 0.28rem;
  margin-top: 0.1rem;
  font-size: 0.14rem;
  text-align: center;
  background-image: linear-gradient(90deg, #fd503e 0%, #f7603e 100%);
  background: #ffdaad;
  border-radius: 0.16rem;
  flex-grow: 0;
  color: #6a440d;
}
.online-consult-card .banner-ad-regulation {
  padding: 0;
}
.online-consult-card .blue-font {
  color: #445fbb;
  font-weight: 600;
}
.online-consult-card .lawyers-box {
  width: 100%;
  height: auto;
  padding: 0.18rem 0;
  position: relative;
  font-family: PingFangSC-Regular;
}
.online-consult-card .lawyers-box .shadow {
  width: 0.13rem;
  height: 1.73rem;
  position: absolute;
  bottom: 0.18rem;
  z-index: 2;
}
.online-consult-card .lawyers-box .shadow-left {
  background-image: linear-gradient(90deg, #fff 0%, rgba(255, 255, 255, 0) 100%);
  left: 0;
}
.online-consult-card .lawyers-box .shadow-right {
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
  right: 0;
}
.online-consult-card .lawyers-box .lawyer-title {
  font-size: 18px;
  color: #1f1f1f;
  letter-spacing: 0;
  line-height: 0.18rem;
  margin-bottom: 0.15rem;
}
.online-consult-card .lawyers-box .lawyer-list::-webkit-scrollbar {
  display: none;
}
.online-consult-card .lawyers-box .lawyer-list {
  width: 100%;
  height: 1.73rem;
  overflow-x: scroll;
}
.online-consult-card .lawyers-box .lawyer-list-scroll {
  width: auto;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
}
.online-consult-card .lawyers-box .lawyer-list-scroll-item {
  min-width: 1.27rem;
  height: 1.73rem;
  background: #fff;
  border: 0.01rem solid #f3f3f3;
  border-radius: 0.09rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 0.15rem;
  box-sizing: border-box;
  margin-right: 0.1rem;
  float: left;
}
.online-consult-card .lawyers-box .lawyer-list-scroll-item .lawyer-img {
  width: 0.52rem;
  height: 0.52rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 0.11rem;
  background: #525252;
  border-radius: 50%;
}
.online-consult-card .lawyers-box .lawyer-list-scroll-item .lawyer-img-item {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.online-consult-card .lawyers-box .lawyer-list-scroll-item .lawyer-img-vip {
  width: 0.32rem;
  height: 0.18rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background: #faa90e;
  border-radius: 0.09rem;
  top: 0.39rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.12rem;
  color: #fff;
  line-height: 10px;
}
.online-consult-card .lawyers-box .lawyer-list-scroll-item .lawyer-name {
  font-family: PingFangSC-Semibold;
  font-size: 0.18rem;
  color: #111;
  line-height: 0.18rem;
  font-weight: 600;
  margin-bottom: 0.08rem;
}
.online-consult-card .lawyers-box .lawyer-list-scroll-item .lawyer-years {
  font-size: 0.14rem;
  color: #555;
  line-height: 0.14rem;
  margin-bottom: 0.12rem;
}
.online-consult-card .lawyers-box .lawyer-list-scroll-item .lawyer-more {
  padding: 0.41rem 0;
  margin-bottom: 0.15rem;
  font-size: 0.18rem;
  color: #111;
  text-align: center;
  line-height: 0.18rem;
}
.online-consult-card .lawyers-box .lawyer-list-scroll-item .lawyer-btn {
  width: 0.67rem;
  height: 0.28rem;
  background: #fcfcff;
  border: 1px solid #445fbb;
  border-radius: 0.17rem;
  text-align: center;
  line-height: 0.28rem;
  font-family: PingFangSC-Medium;
  font-size: 0.12rem;
  color: #445fbb;
  letter-spacing: 0;
  font-weight: 500;
  position: relative;
}
.online-consult-card .lawyers-box .lawyer-list-scroll-item:last-child {
  margin-right: 0;
}
.online-consult-card-border {
  border-bottom: 1px solid #f3f3f3;
}

</style>
